import {useCallback, useRef} from 'react';

interface ScrollToElementOptions {
  offset?: number;
  behavior?: ScrollBehavior;
  block?: ScrollLogicalPosition;
}

export const useScrollToElement = ({
  offset = 0,
  behavior = 'smooth',
  block = 'center'
}: ScrollToElementOptions = {}) => {
  const ref = useRef<HTMLDivElement | null>(null);

  const scrollToElement = useCallback(() => {
    if (!ref.current) return;

    if (!offset) {
      ref.current.scrollIntoView({
        behavior,
        block,
        inline: 'nearest'
      });
      return;
    }

    const rect = ref.current.getBoundingClientRect();
    const top = rect.top + window.pageYOffset - offset;

    window.scrollTo({
      top,
      behavior
    });
  }, [offset, behavior, block]);

  return {
    ref,
    scrollToElement
  };
};
